import React from 'react';
import './Logo.css';

const Logo = () => {
  return (
    <div className="logo">
      <img
        src="/assets/imgs/logo-orange.png"
        alt="Logo da Fcamara Orange Juice"
      />
    </div>
  );
};

export default Logo;
